import { put, call } from 'redux-saga/effects'

import { BFFAgent } from '../../../../common/BFFAgent'
import {
  STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_SUCCESS,
  STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_FAILURE
} from '../constants'

export function* getVersionsDataMasterSaga({data:{brandId, modelId, year}}) {
  try {
      
    if(brandId && modelId && year){

      const result =  yield call(BFFAgent.Datamasters.getVersions, brandId, modelId, year)
      const versionsList = result?.data?.data

      yield put({
          type: STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_SUCCESS,
          data: versionsList
      })

    } else {

      yield put({
        type: STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_FAILURE,
        data: { error: 'Se necesita el Id de la marca, modelo y/o año' }
      })
      
    }
      
  } catch (error) {
    yield put({
      type: STOCK_TAKING_CAR_MANAGEMENT_VERSIONS_DATA_MASTER_FAILURE,
      data: { error }
    })
  }
}
